import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-permissions";
import PaymentMethodsConfigurations from "@/components/logistics/payment-methods/payment-methods-configurations";

export const Route = createFileRoute(
  "/_authenticated/settings/_layout/payment-methods",
)({
  component: PaymentMethodsConfigurationsPage,
});

function PaymentMethodsConfigurationsPage() {
  return (
    <RouteGuardPermissions
      permissions={[
        { module: "logistics_payment_methods", actions: ["read", "update"] },
      ]}
    >
      <div className="overflow-x-auto">
        <PaymentMethodsConfigurations />
      </div>
    </RouteGuardPermissions>
  );
}
